import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { EntriModule } from '../../ModalsExtensions';
export const entriConnectAction = async _ref => {
  let {
    domainName,
    msid,
    siteName,
    overrideEntriEligibility,
    isNonWixEditorSite,
    fullPage,
    t
  } = _ref;
  const {
    httpClient
  } = getPremiumEssentials();
  const {
    domainsLogger
  } = DomainsApiClient.queries({
    httpClient: httpClient
  });
  domainsLogger({
    entity: 'useConnectAction',
    type: 'info',
    metadata: {
      domainName
    }
  });
  try {
    const result = await EntriModule.SDK.startEntriFlow({
      domain: domainName,
      siteName,
      metaSiteId: msid,
      // TODO: add enabledBySpec should be taken from the host app
      enabledBySpec: 'specs.premium.domain.enableEntriInConcierge',
      disablePointing: isNonWixEditorSite,
      overrideEntriEligibility,
      fullPage,
      t
    });
    return result;
  } catch (e) {
    domainsLogger({
      entity: 'entriConnectAction',
      type: 'error',
      metadata: {
        domainName
      },
      error: e,
      message: 'Error in connectAction',
      stack: e == null ? void 0 : e.stack
    });
    throw e;
  }
};
//# sourceMappingURL=entriConnectAction.js.map